import React from 'react';

function About() {
  return (
    <div>
      <h1>About ThirdWave Microcare Foundation</h1>
      <p>
        ThirdWave Microcare is dedicated to delivering cutting-edge healthcare solutions that improve lives.
        With a strong focus on innovation and patient-centered care, we partner with healthcare professionals,
        institutions, and communities to build a healthier tomorrow.
      </p>
      <p>
        Our team consists of experts in medical technology, research, and healthcare services. 
        We strive to bring affordable, effective, and sustainable healthcare innovations to the global market.
      </p>
    </div>
  );
}

export default About;
